import { FC, InputHTMLAttributes } from 'react';
import tw, { styled } from 'twin.macro';
import 'styled-components/macro';

import { Icon } from '../icon/Icon';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  disabled?: boolean;
  icon?: string;
  label?: string;
  placeholder?: string;
}

export const SearchInput: FC<InputProps> = ({ disabled, icon = 'search', placeholder, ...props }) => (
  <div
    tw="block relative text-primary-light"
    css={{
      'input:focus:not(:disabled) + *, input:hover:not(:disabled) + *': tw`text-primary`,
      height: 'max-content',
    }}
  >
    <FormControl {...props} type="search" disabled={disabled} placeholder={placeholder} />
    {icon && (
      <div tw="pointer-events-none absolute inset-y-0 right-0 pr-2 flex items-center transition duration-fast">
        <Icon name={icon} />
      </div>
    )}
  </div>
);

const FormControl = styled.input`
  ${tw`
    appearance-none
    bg-white
    duration-fast
    outline-none
    pl-3
    placeholder-primary-light
    pr-6
    py-1
    ring-inset
    ring-primary
    rounded-full
    text-base/snug
    text-primary
    transition
    w-full

    hover:not-disabled:(placeholder-primary ring-1)
    focus:not-disabled:(placeholder-primary ring-2)
    disabled:(bg-gray-5 placeholder-gray-15)
  `}

  &::-webkit-search-cancel-button {
    appearance: none;
  }
`;
